export const convertSearchString = (str: string): string => {
  const searchLength = str.replace('type:', '').trim().split(' ').length;

  if (searchLength > 1 && str.includes('type:')) {
    // eslint-disable-next-line no-useless-escape
    return `${str.trim().replace('type:', 'type:"')}\"`;
  }
  return str;
};
